{
  "version": 1,
  "asset_id": "140963b9-35ab-4112-ae0d-61af80ddd09a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/140963b9-35ab-4112-ae0d-61af80ddd09a/dr-fitzer-home-900.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/140963b9-35ab-4112-ae0d-61af80ddd09a/dr-fitzer-home-900.webp",
  "original_filename": "dr-fitzer-home-900.webp",
  "size": 44124,
  "content_type": "image/webp",
  "created_at": "2026-07-23T11:52:25Z"
}
